/* eslint-disable no-sequences */
// AXIOS
import axios from "axios";

// api url
import { apiToken, apiUrl_forBlog } from "./constants";

// cancel token
const CancelToken = axios.CancelToken;

// get blogs
export let cancelGetBlogsApi;
export async function getBlogs(token, query = "") {
    if (token) {
        const blogs = await axios.get(apiUrl_forBlog + "?" + query, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetBlogsApi = c;
            }),
        });
        return blogs;
    } else {
        console.log("Please add required parameters");
    }
}

// get blog detail
export let cancelGetBlogDetailsApi;
export async function getBlogDetails(token, blogId) {
    if (token && blogId) {
        const blogs = await axios.get(apiUrl_forBlog + "" + blogId, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetBlogDetailsApi = c;
            }),
        });
        return blogs;
    } else {
        console.log("Please add required parameters");
    }
}

// get events
export let cancelGetBlogEventsApi;
export async function getBlogEvents(token) {
    if (token) {
        const blogs = await axios.get(apiUrl_forBlog + "blogevents/", {
            headers: {
                Authorization: `Bearer ${token}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetBlogEventsApi = c;
            }),
        });
        return blogs;
    } else {
        console.log("Please add required parameters");
    }
}

// add blog
export let cancelAddBlogApi;
export async function addBlog(token, blogData) {
    if ((token, blogData)) {
        const blogs = await axios.post(
            apiUrl_forBlog + "",
            {
                title: blogData.title,
                author_name: blogData.author_name,
                description: blogData.description,
                meta_title: blogData.meta_title,
                meta_description: blogData.meta_description,
                tags: blogData.tags,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddBlogApi = c;
                }),
            }
        );
        return blogs;
    } else {
        console.log("Please add required parameters");
    }
}

// update blog
export let cancelEditBlogApi;
export async function editBlog(token, blogData) {
    if ((token, blogData)) {
        const blogs = await axios.put(
            apiUrl_forBlog + "" + blogData.blog_id,
            {
                title: blogData.title,
                author_name: blogData.author_name,
                description: blogData.description,
                meta_title: blogData.meta_title,
                meta_description: blogData.meta_description,
                tags: blogData.tags,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelEditBlogApi = c;
                }),
            }
        );
        return blogs;
    } else {
        console.log("Please add required parameters");
    }
}

// delete blog
export let cancelDeleteBlogApi;
export async function deleteBlog(token, blogId) {
    if ((token, blogId)) {
        const blogs = await axios.delete(
            apiUrl_forBlog + "" + blogId,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelDeleteBlogApi = c;
                }),
            }
        );
        return blogs;
    } else {
        console.log("Please add required parameters");
    }
}
